import { render, staticRenderFns } from "./EditColumnsButton.vue?vue&type=template&id=8c02acba&"
import script from "./EditColumnsButton.vue?vue&type=script&lang=js&"
export * from "./EditColumnsButton.vue?vue&type=script&lang=js&"
import style0 from "./EditColumnsButton.vue?vue&type=style&index=0&id=8c02acba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports